import type { BadgeStyleParams } from '@atoms/badges/badgeStyle';

export const PAYOUT_DRAFTS_STATUS = {
  WAITING_REVIEW: 'waiting_review',
  REJECTED: 'rejected'
} as const;

export type PayoutDraftState = {
  id: string;
  value:
    | (typeof PAYOUT_DRAFTS_STATUS)[keyof typeof PAYOUT_DRAFTS_STATUS]
    | string;
  order: number;
  label: string;
  style: BadgeStyleParams;
};
